

const BorderDivider = ({ borderStyle }:{
    borderStyle?:object | {}
}) => (
    <div className="borderDivider" style={borderStyle}>
    </div>
);

export default BorderDivider;